import EditPencilIcon from "@redotech/redo-icons/edit-01.svg";
import FolderOpenIcon from "@redotech/redo-icons/folder-open.svg";
import FolderIcon from "@redotech/redo-icons/folder.svg";
import { memo, ReactNode } from "react";
import { RedoSecondaryNavItem } from "./redo-secondary-nav-item";

export const RedoNavFolder = memo(function RedoNavFolder({
  children,
  folderEditRequested,
  folderId,
  folderName,
  anyChildSelected,
}: {
  folderId: string;
  folderName: string;
  anyChildSelected: boolean;
  children: ReactNode | ReactNode[];
  folderEditRequested: () => void;
}) {
  return (
    <RedoSecondaryNavItem
      action={{ type: "button" }}
      anyChildSelected={anyChildSelected}
      data-arbiter="RedoNavFolder"
      FilledIcon={FolderOpenIcon}
      friendlyName={folderName}
      id={folderId}
      isFolder
      UnfilledIcon={FolderIcon}
    >
      {[
        children,
        <RedoSecondaryNavItem
          action={{ type: "button", onClick: folderEditRequested }}
          FilledIcon={EditPencilIcon}
          friendlyName="Edit folder"
          id="edit-folder"
          key="edit-folder"
          UnfilledIcon={EditPencilIcon}
        />,
      ]}
    </RedoSecondaryNavItem>
  );
});
